import { useEffect, useState } from 'react';

export const DEBOUNCE_SEARCH_MS = 300;

export function useDebounceSearch<T>(
	searchTerm: T,
	customDebounceMs = DEBOUNCE_SEARCH_MS
): T {
	const [debouncedValue, setDebouncedValue] = useState(searchTerm);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(searchTerm);
		}, customDebounceMs);

		return () => clearTimeout(handler);
	}, [customDebounceMs, searchTerm]);

	return debouncedValue;
}
